import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Container, Text } from "@chakra-ui/react";
import { Link } from "wouter";
export const NotFound = () => (_jsxs(Container, { children: [_jsx(Text, Object.assign({ fontSize: "2xl", mt: 4 }, { children: "\u30DA\u30FC\u30B8\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F\uD83D\uDE22" }), void 0),
        _jsx(Link, Object.assign({ href: "/" }, { children: _jsx(Button, { children: "\u623B\u308B" }, void 0) }), void 0)] }, void 0));
